import React from 'react';
import { useGetPlaylistsQuery } from 'app/api/assetApi';
import { FileGroupPanel } from './FileGroupPanel';
import { GROUPBY_PLAYLIST } from '../filePlayerConstants';

const transformPlaylistsToGroups = (queryResult) => {
  const { data, ...rest } = queryResult;

  const transformed = data
    ? {
      items: data.map((pl) => ({
        id: pl.id,
        label: pl.title,
        fileCount: pl.fileCount,
        filters: { playlistId: pl.id },
      })),
      nextCursor: null,
    }
    : null;

  return {
    ...rest,
    data: transformed,
  };
};

export const PlaylistTab = () => {
  const playlistResult = useGetPlaylistsQuery();

  return (
    <FileGroupPanel
      queryResult={transformPlaylistsToGroups(playlistResult)}
      onLoadMore={() => {}}
      groupBy={GROUPBY_PLAYLIST}
    />
  );
};
